/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';
import { useTheme } from '../../theme';
const ListItemCheckbox = React.forwardRef((props, ref) => {
    const theme = useTheme();
    return (jsx("span", Object.assign({}, props, { ref: ref, css: {
            backgroundColor: theme.colors.listItemCheckbox,
            cursor: 'pointer',
        } })));
});
ListItemCheckbox.displayName = 'ListItemCheckbox';
export default React.memo(ListItemCheckbox);
//# sourceMappingURL=ListItemCheckbox.js.map